import { useContext, useEffect, useState } from "react";
import { GlobalInfo } from "../../../Contexts/GlobalContext";
import { useNavigate, useParams, Link } from "react-router-dom";
import { AdminService } from "../../../Services/Admin.service";
import Toaster from "../../../Components/Toaster";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import Loader from "../../../Components/Loader";
import Rest from '../../../Services/Rest';
import TokenService from '../../../Services/Token.service';
import { OverlayTrigger, Popover, Button } from "react-bootstrap";
import { IoMdInformationCircleOutline } from "react-icons/io";
const checkIfExists = (column, value) => {
    return Rest.post(`/user/exists`, { column, value })
        .then(response => response.data.exists)
        .catch(error => {
            console.error('Error checking if exists:', error);
            return false;
        });
};

// Validation Schema using Yup
const validationSchema = Yup.object().shape({
    first_name: Yup.string().required('First Name is required'),
    middle_name: Yup.string().required('Middle Name is required'),
    last_name: Yup.string().required('Last Name is required'),
    username: Yup.string()
        .required('User Name is required')
        .min(3, 'User Name must be at least 3 characters long')
        .matches(/^[a-zA-Z0-9]+$/, 'User Name must be alphanumeric')
        // .test('username-unique', 'User Name already exists', function (value) {
        //     if (!value) return true;
        //     return checkIfExists('username', value).then((exists) => {
        //         return !exists;
        //     });
        // })
        ,
    email: Yup.string()
        .email('Invalid email format')
        // .matches(/^[^@\s]+@[^@\s]+\.[^@\s]+$/, 'Invalid email address')
        .matches(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, 'Invalid email format')
        .required('Email is required')
        // .test('email-unique', 'Email already exists', function (value) {
        //     if (!value) return true;
        //     return checkIfExists('email', value).then((exists) => {
        //         return !exists;
        //     });

        // })
        ,
    password: Yup.string()
        .required('Password is required')
        .min(8, 'Password must be at least 8 characters long')
        .max(20, 'Password must not be greater than 20 characters')
        .matches(/[A-Z]/, 'Must contain at least one uppercase letter')
        .matches(/[a-z]/, 'Must contain at least one lowercase letter')
        .matches(/[0-9]/, 'Must contain at least one digit')
        .matches(/[!@#$%^&*(),.?":{}|<>]/, 'Must contain at least one special character'),
    confirm_password: Yup.string()
        .oneOf([Yup.ref('password'), null], 'Passwords must match')
        .required('Confirm Password is required'),
    phone_number: Yup.string()
        .matches(/^[0-9]{10}$/, 'Phone Number must be 10 digits')
        .required('Phone Number is required'),
    // gender: Yup.string().required('Gender is required'),
});

function AddAdmin() {
    const navigate = useNavigate();
    const { appUserIsLogin, theme, toggleSidebar, isSidebarVisible } = useContext(GlobalInfo);
    const { type } = useParams();

    const [showToast, setShowToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');
    const [toastVariant, setToastVariant] = useState('');
    const [loading, setLoading] = useState(false);
    const [adminMenuList, setAdminMenuList] = useState([]);
    const [checkedItems, setCheckedItems] = useState({});
    const previousUrl = TokenService.getPrevLink();

    const [navigateToAdmin, setNavigateToAdmin] = useState(false);
    const initialValues = {
        first_name: '',
        middle_name: '',
        last_name: '',
        username: '',
        email: '',
        password: '',
        confirm_password: '',
        phone_number: '',
        // gender: 'XY',
    };

    useEffect(() => {
        const fetchAdminMenuList = async () => {
            try {
                const menuList = await AdminService.getAdminMenuList();
                setAdminMenuList(menuList.menu);
            } catch (err) { 
                const message = err.response?.status === 404
                    ? 'Permission list not found.'
                    : 'Failed to get permission list. Please contact administrator.';
                setToastMessage(message);
                setToastVariant('error');
                setShowToast(true);
            }
        };
        fetchAdminMenuList();
    }, []);

    const handleAccessPermissionChange = (e, slug, isParent = false) => {
        const isChecked = e.target.checked;
        setCheckedItems((prev) => {
            const newItems = { ...prev, [slug]: isChecked };
            if (isParent) {
                const parentItem = adminMenuList.find(item => item.slug === slug);
                parentItem?.children?.forEach(child => {
                    newItems[child.slug] = isChecked;
                });
            } else {
                const parentSlug = adminMenuList.find(item =>
                    item.children?.some(child => child.slug === slug)
                )?.slug;
                if (parentSlug) {
                    const anyChildChecked = adminMenuList
                        .find(item => item.slug === parentSlug)
                        ?.children.some(child => newItems[child.slug]);
                    newItems[parentSlug] = anyChildChecked;
                }
            }
            return newItems;
        });
    };

    const handleSubmit = async (values, { resetForm , setSubmitting, setFieldError}) => {
        const emailExists = await checkIfExists('email', values.email);
        if (emailExists) {
            setFieldError('email', 'Email already exists');
            setSubmitting(false);
            return;
        }

        const usernameExists = await checkIfExists('username', values.username);
        if (usernameExists) {
            setFieldError('username', 'User Name already exists');
            setSubmitting(false);
            return;
        }

        setLoading(true);
        const userData = {
            first_name: values.first_name,
            middle_name: values.middle_name,
            last_name: values.last_name,
            username: values.username,
            email: values.email,
            password: values.password,
            phone_number: values.phone_number,
            // gender: values.gender,
            sequence: 1,
            is_superadmin: type === 'superadmin' ? 1 : 0,
            user_type: type === 'superadmin' ? [] : [1],
            menu_access: Object.keys(checkedItems).filter(slug => checkedItems[slug]),
        };

        try {
            const data = await AdminService.addAdminUser(userData);
            if (!data.status) {
                setToastMessage(data.error);
                setToastVariant('error');
            } else {
                
                resetForm();
                setCheckedItems({});
            

                setNavigateToAdmin(true);
            }

        } catch (error) {
            setToastMessage('Failed to add admin user.');
            setToastVariant('error');
        } finally {
            setLoading(false);
            // setShowToast(true);
        }
    };
    // UseEffect to handle navigation
    useEffect(() => {
        if (navigateToAdmin) {
            const timer = setTimeout(() => {
                // administrative-settings
                navigate('/admin/admin-management',{state: {
                    toastMessage: 'Admin added successfully!',
                    toastVariant: 'success',
                }},);
            }, 2000);
            return () => clearTimeout(timer);
        }
    }, [navigateToAdmin]);
    return (
        <>
            <Loader loading={loading} />
            <div className={`${!isSidebarVisible ? 'collapsed-body' : ''}`}>
                <div className="el-middle-wrapper">
                    <h2 className="el-title">
                        Add New {type === 'superadmin' ? 'Super Admin' : 'Admin'}
                    </h2>
                    <Link className="back-link" to={`${previousUrl}`}><i className='el-icon-back'></i> Admin Management</Link>

                    <div className="el-bg-table el-super-admin">
                        <Formik
                            initialValues={initialValues}
                            validationSchema={validationSchema}
                            onSubmit={handleSubmit}
                            validateOnChange={false}
                            validateOnBlur={true}
                        >
                            {({ errors, touched }) => (
                                <Form>
                                    {/* {Object.keys(errors).length > 0 && (
                                        <div className="alert alert-danger">
                                            {Object.values(errors).map((error, index) => (
                                                <div key={index}>{error}</div>
                                            ))}
                                        </div>
                                    )} */}
                                    <div className="mt-3 mt-md-0 col-md-12">
                                        <div className="row">
                                            {/* Input Fields */}
                                            {['first_name', 'middle_name', 'last_name', 'email', 'phone_number'].map(field => (
                                                <div className="col-md-4" key={field}>
                                                    <label htmlFor={field} className="form-label">
                                                        {field
                                                            .replace(/_/g, ' ')
                                                            .trim()
                                                            .replace(/\b\w/g, (char) => char.toUpperCase())
                                                        }<span className="text-red">*</span>
                                                    </label>
                                                    <Field
                                                        type={field.includes('phone_number') ? 'number' : 'text'}
                                                        maxLength={field === 'phone_number' ? 10 : undefined}
                                                        onInput={(e) => {
                                                            if (['first_name', 'middle_name', 'last_name'].includes(field)) {
                                                                e.target.value = e.target.value.replace(/[^a-zA-Z]/g, '').slice(0, 50);
                                                            } else if (field === 'phone_number' && e.target.value.length > 10) {
                                                                e.target.value = e.target.value.replace(/[^0-9]/g, '').slice(0, 10);
                                                            }
                                                            else if (field === 'email') {
                                                                // e.target.value = e.target.value.slice(0, 50);
                                                                e.target.value = e.target.value.replace(/\s/g, '').slice(0, 50);
                                                            }
                                                            else {
                                                                // e.target.value = e.target.value.replace(/[^a-zA-Z0-9 ]/g, '').slice(0, 50);
                                                                e.target.value = e.target.value.replace(/\s/g, '').replace(/[^a-zA-Z0-9]/g, '').slice(0, 50);
                                                            }
                                                        }}
                                                        placeholder = {`Enter ${field
                                                            .replace(/_/g, ' ')
                                                            .trim()
                                                            .replace(/\b\w/g, (char) => char.toUpperCase())}`}
                                                        name={field}
                                                        className={`form-control ${field === 'phone_number' ? 'no-arrows' : ''}`}
                                                    />
                                                    <div className="mt-1">
                                                        <ErrorMessage name={field} component="div" className="text-danger" />
                                                    </div>
                                                </div>
                                            ))}

                                            {/* Gender Selection */}
                                            {/* <div className="col-md-4">
                                                <label className="form-label px-0">Biological Sex<span className="text-red">*</span></label>
                                                <div className="d-flex justify-content-between w-40 mt-1 align-items-center mt-3 ms-3">
                                                    {['XY', 'XX'].map((gender) => (
                                                        <div className="form-check mb-0" key={gender}>
                                                            <Field id={`biological_sex_${gender}`} type="radio" name="gender" value={gender} className="form-check-input radio-pointer" />
                                                            <label htmlFor={`biological_sex_${gender}`} className="form-check-label radio-pointer">&nbsp; {gender}</label>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div> */}

                                            {['username', 'password', 'confirm_password'].map(field => (
                                                <div className="col-md-4" key={field}>
                                                    <label htmlFor={field} className={`${field != 'password' ? 'mt-2' : ''} form-label`}>
                                                        {field
                                                            .replace(/_/g, ' ') // Replace underscores with spaces
                                                            .trim() // Remove extra spaces
                                                            .replace(/\b\w/g, (char) => char.toUpperCase())
                                                        }
                                                        <span className="text-red">* </span>
                                                        {field == 'password' && (
                                                            <OverlayTrigger
                                                                placement="right"
                                                                overlay={
                                                                    <Popover id={`popover-${field}`}>
                                                                        <Popover.Header as="h5">Password Guidelines</Popover.Header>
                                                                        <Popover.Body>
                                                                            <ul>
                                                                                <li>At least 8 characters long</li>
                                                                                <li>At least one uppercase letter</li>
                                                                                <li>At least one number</li>
                                                                                <li>At least one special character</li>
                                                                            </ul>
                                                                        </Popover.Body>
                                                                    </Popover>
                                                                }
                                                            >
                                                                <Button variant="link" className="password-info-btn p-0 m-0" style={{ fontSize: '16px' }}>
                                                                    <IoMdInformationCircleOutline />
                                                                </Button>
                                                            </OverlayTrigger>
                                                        )}
                                                    </label>
                                                    <Field
                                                        type={field.includes('password') ? 'password' : 'text'}
                                                        maxLength={field === 'phone_number' ? 10 : undefined}
                                                        onInput={(e) => {
                                                            if (field === 'phone_number' && e.target.value.length > 10) {
                                                                e.target.value = e.target.value.slice(0, 10);
                                                            } else if (field.includes('password') && e.target.value.length > 20) {
                                                                e.target.value = e.target.value.slice(0, 20);
                                                            }
                                                            else if (field === 'username') {
                                                                // e.target.value = e.target.value.replace(/[^a-zA-Z0-9 ]/g, '').slice(0, 50);
                                                                e.target.value = e.target.value.replace(/\s/g, '').replace(/[^a-zA-Z0-9]/g, '').slice(0, 50);
                                                            }
                                                            else {
                                                                // e.target.value = e.target.value.slice(0, 50);
                                                                e.target.value = e.target.value.replace(/\s/g, '').slice(0, 50);
                                                            }
                                                        }}
                                                        name={field}
                                                        className="form-control"
                                                        placeholder={`Enter ${field
                                                            .replace(/_/g, ' ')
                                                            .trim()
                                                            .replace(/\b\w/g, (char) => char.toUpperCase())}`}
                                                    />
                                                    <div className="mt-1">
                                                        <ErrorMessage name={field} component="div" className="text-danger" />
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>

                                    {/* Admin Permissions */}
                                    {type === 'admin' && (
                                        <div className="row mt-3">
                                            <h3 className="mb-3"><b>Select Admin Permissions</b></h3>
                                            {adminMenuList.map(menuItem => (
                                                <div key={menuItem.slug} className="col-md-5 mt-3">
                                                    <div className="form-check mb-3">
                                                        <input
                                                            type="checkbox"
                                                            className="form-check-input"
                                                            checked={!!checkedItems[menuItem.slug]}
                                                            onChange={(e) => handleAccessPermissionChange(e, menuItem.slug, true)}
                                                        />
                                                        <label className="form-check-label">{menuItem.name}</label>
                                                    </div>
                                                    {menuItem.children?.length > 0 && (
                                                        <div className="row child-wrapper">
                                                            {menuItem.children.map(child => (
                                                                <div key={child.slug} className="child-menu-permission col-md-12">
                                                                    <div className="form-check mb-3">
                                                                        <input
                                                                            type="checkbox"
                                                                            className="form-check-input"
                                                                            checked={!!checkedItems[child.slug]}
                                                                            onChange={(e) => handleAccessPermissionChange(e, child.slug)}
                                                                        />
                                                                        <label className="form-check-label">{child.name}</label>
                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    )}
                                                </div>
                                            ))}
                                        </div>
                                    )}

                                    <div className="mt-3 d-flex align-items-center">
                                    <button type="submit" className="el-main-button me-3"> <span> Submit</span></button>
                                    <Link className="back-link ms-3" to={`${previousUrl}`}>Close</Link>
                                    </div>
                                </Form>
                            )}
                        </Formik>
                    </div>
                    <Toaster
                        show={showToast}
                        message={toastMessage}
                        variant={toastVariant}
                        onClose={() => setShowToast(false)}
                    />
                </div>
            </div>
        </>
    );
}

export default AddAdmin;
